import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/gopath/src/github.com/rumblefrog/source-chat-relay/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "protocol"
    }}>{`Protocol`}</h1>
    <h2 {...{
      "id": "message-types"
    }}>{`Message Types`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-cpp"
      }}>{`enum MessageType
{
    MessageInvalid = 0,
    MessageAuthenticate,
    MessageAuthenticateResponse,
    MessageChat,
    MessageEvent,
    MessageTypeCount,
}
`}</code></pre>
    <h2 {...{
      "id": "authenticate-response-types"
    }}>{`Authenticate Response Types`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-cpp"
      }}>{`enum AuthenticateResponse
{
    AuthenticateInvalid = 0,
    AuthenticateSuccess,
    AuthenticateDenied,
    AuthenticateResponseCount,
}
`}</code></pre>
    <h2 {...{
      "id": "identification-types"
    }}>{`Identification Types`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-cpp"
      }}>{`enum IdentificationType
{
    IdentificationInvalid = 0,
    IdentificationSteam,
    IdentificationDiscord,
    IdentificationTypeCount,
}
`}</code></pre>
    <h2 {...{
      "id": "chat-message-format"
    }}>{`Chat Message Format`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Data`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Comment`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Header`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`byte`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`MessageChat`}</inlineCode>{` value of `}<inlineCode parentName="td">{`MessageType`}</inlineCode>{` enum`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`EntityName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Entity name of the host sending the message`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`IDType`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`byte`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Item from `}<inlineCode parentName="td">{`IdentificationType`}</inlineCode>{` enum`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ID`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Unique identification of the user`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Username`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name of the user sending the message`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Message`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Message content`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "event-message-format"
    }}>{`Event Message Format`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Data`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Comment`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Header`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`byte`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`MessageEvent`}</inlineCode>{` value of `}<inlineCode parentName="td">{`MessageType`}</inlineCode>{` enum`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`EntityName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Entity name of the host sending the message`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Event`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name of the event`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Data`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Data of the event`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "authenticate-message-format"
    }}>{`Authenticate Message Format`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Data`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Comment`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Header`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`byte`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`MessageAuthenticate`}</inlineCode>{` value of `}<inlineCode parentName="td">{`MessageType`}</inlineCode>{` enum`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`EntityName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Entity name of the host sending the message`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Token`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Authentication token`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "authenticate-response-message-format"
    }}>{`Authenticate Response Message Format`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Data`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Comment`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Header`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`byte`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`MessageAuthenticate`}</inlineCode>{` value of `}<inlineCode parentName="td">{`MessageType`}</inlineCode>{` enum`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`EntityName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`stringSz`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Entity name of the host sending the message`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Response`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`byte`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Item from `}<inlineCode parentName="td">{`AuthenticateResponse`}</inlineCode>{` enum`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      